import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/content/site";
import { Reveal, MaskLine, EASE } from "./Reveal";
import { SectionHead } from "./Bits";
import { scrollToId } from "@/lib/scroll";

const LAYOUT = [
  "md:col-span-2 lg:col-span-1 lg:row-span-2",
  "",
  "",
  "",
  "",
  "md:col-span-2 lg:col-span-3",
];

const Card = ({ s, i }) => (
  <motion.article
    data-testid={`service-card-${s.id}`}
    className={`group relative h-[420px] overflow-hidden bg-[#1E2228] md:h-auto ${LAYOUT[i]}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, delay: (i % 3) * 0.1, ease: EASE }}
  >
    {s.stock && <span className="absolute right-[4.75rem] top-9 z-10 bg-[#1E2228]/70 px-2 py-1 text-[10px] uppercase tracking-[0.14em] text-white/85">Imagen ilustrativa</span>}
    <img src={s.image} alt={s.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#1E2228]/95 via-[#1E2228]/45 to-[#1E2228]/5" />
    <div className="relative flex h-full flex-col justify-between p-6 sm:p-8">
      <div className="flex items-start justify-between">
        <span className="font-serif-it text-3xl text-[#E5D3B3]">0{i + 1}</span>
        <button
          data-testid={`service-cta-${s.id}`}
          onClick={() => scrollToId("contacto")}
          aria-label={`Solicitar información sobre ${s.title}`}
          className="grid h-11 w-11 place-items-center rounded-full border border-white/40 text-white transition-[background-color,color,transform] duration-500 group-hover:rotate-45 hover:bg-[#B8955F] hover:text-[#1E2228]"
        >
          <ArrowUpRight className="h-4 w-4" />
        </button>
      </div>
      <div className={i === 5 ? "max-w-xl" : ""}>
        <span className="mb-4 block h-px w-10 bg-[#C9A66B] transition-[width] duration-700 group-hover:w-24" />
        <h3 className="font-display text-xl font-semibold uppercase leading-tight tracking-[0.04em] text-white sm:text-2xl">{s.title}</h3>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-white/85 sm:text-base">{s.desc}</p>
      </div>
    </div>
  </motion.article>
);

export default function Services() {
  return (
    <section id="servicios" data-testid="services-section" className="bg-[#F6F4EF] py-24 sm:py-32">
      <div className="container-x">
        <div className="mb-14 grid gap-8 lg:mb-20 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <Reveal><SectionHead index="01" eyebrow="Servicios" /></Reveal>
            <h2 className="mt-6 font-display text-3xl font-light uppercase leading-[1.08] text-[#1E2228] sm:text-5xl lg:text-6xl">
              <MaskLine inView>Todo lo que tu</MaskLine>
              <MaskLine inView delay={0.1}>espacio <span className="font-serif-it normal-case text-[#8A6C3E]">necesita</span></MaskLine>
            </h2>
          </div>
          <Reveal delay={0.15} className="lg:col-span-5">
            <p className="text-base leading-relaxed text-[#3A414B] sm:text-lg">
              Un único equipo para diseñar, reformar y construir, con una visión de conjunto y el cuidado de cada acabado.
            </p>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:auto-rows-[340px] lg:grid-cols-3 lg:auto-rows-[320px] lg:gap-5">
          {SERVICES.map((s, i) => <Card key={s.id} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
}
